import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import throttle from 'lodash/throttle';
import { NAV_HEIGHT_WITH_MARGIN } from '../constants';

type OwnProps = {
  onScrollCallback: () => void;
};

const ScrollHandler = ({ onScrollCallback }: OwnProps) => {
  const location = useLocation();

  const handleScroll = useCallback(
    throttle(() => {
      onScrollCallback();
    }, 400),
    []
  );

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    const element = document.getElementById(location.hash);

    setTimeout(() => {
      window.scrollTo({
        behavior: element ? 'smooth' : 'auto',
        top: element ? element.offsetTop - NAV_HEIGHT_WITH_MARGIN : 0,
      });
    }, 100);
  }, [location]);

  return null;
};

export default ScrollHandler;
